import React from "react";

import Text from "cms/components/Text";
import LeftCursor from "cms/images/left-cursor.svg";
import magicIcon from "cms/images/magic-star-icon-white.svg";
import RightCursor from "cms/images/right-cursor.svg";
import Button from "../Button";
import { ButtonVariant } from "../Button/Button.styles";
import RichText from "../RichText";
import {
  AiTagContainer,
  AiTagContent,
  AiTagIcon,
  Container,
  CursorIcon,
  Description,
  HeadlineContainer,
  Link,
  ValuePropositionHeaderVariant,
} from "./ValuePropositionHeader.styles";

export interface ValuePropositionHeaderProps {
  headline: Queries.Maybe<string>;
  description: Queries.Maybe<Record<string, unknown>>;
  button: Queries.Maybe<Queries.SanityButton>;
  variant?: ValuePropositionHeaderVariant;
  aiTagText?: string;
}

const ValuePropositionHeader: React.FC<ValuePropositionHeaderProps> = ({
  headline,
  description,
  button,
  variant,
  aiTagText,
}) => (
  <Container>
    {variant === "magic" && (
      <AiTagContainer>
        <AiTagContent>
          <AiTagIcon src={magicIcon} />
          <Text variant="L4" as="label" color="#FFF">
            {aiTagText}
          </Text>
        </AiTagContent>
      </AiTagContainer>
    )}

    <HeadlineContainer $variant={variant}>
      <Text variant="H3" as="h3" textAlign="center" color="inherit">
        {headline}
      </Text>
    </HeadlineContainer>

    <Description $variant={variant}>
      <RichText text={description} variant="B2" />
    </Description>

    {button?.url && button?.label && (
      <Link href={button?.url}>
        <Button
          variant={button?.variant as ButtonVariant}
          label={button?.label}
        />
      </Link>
    )}

    {variant === "cursors" && (
      <React.Fragment>
        <CursorIcon src={RightCursor} $position={{ right: "0%", top: "18%" }} />
        <CursorIcon src={LeftCursor} $position={{ left: "3%", top: "30%" }} />
      </React.Fragment>
    )}
  </Container>
);

export default ValuePropositionHeader;
